import { AppRoutingModule } from './app-routing.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule, provideClientHydration } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { NgxBootstrapModule } from './bootstrapModules/ngx-bootstrap.module';
import { BsDropdownConfig, BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { NgModule, LOCALE_ID, ErrorHandler } from '@angular/core';
import * as Sentry from "@sentry/angular";
import { CommonModule, Location, registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';

import { ToastrModule } from 'ngx-toastr';

registerLocaleData(localeEs, 'es');

import { AppComponent } from './app.component';

import { UserComponent } from './views/user/user.component';

import { AdminComponent } from './views/admin/admin.component';

import { HeaderComponent } from './components/header/header.component';
import { PublicHeaderComponent } from './components/public-header/header.component';
import { RedAlertComponent } from './components/modals/red-alert/red-alert.component';
import { NotFoundComponent } from './views/not-found/not-found.component';
import { RegisterDoneComponent } from './views/register-done/register-done.component';
import { NeurotestComponent } from './views/neurotest/neurotest.component';
import { IntegrationComponent } from './views/integration/integration.component';
import { WorkbookComponent } from './views/workbook/workbook.component';
import { ReferralsComponent } from './views/user/referrals/referrals.component';
import { SafeUrlPipe } from './pipes/safe-url.pipe';
import { FooterComponent } from './components/footer/footer.component';
import { ComplaintsViewComponent } from './views/complaints-view/complaints-view.component';
import { CancellationsAndRefundsComponent } from './views/cancellations-and-refunds/cancellations-and-refunds.component';
import { ScrollTopModule } from './components/scroll-top-floating/scrollTop.module';
import { LoadingComponentsModule } from './components/loadingComponents/loadingComponentsModule.module';
import { LazyImgDirective } from './directives/lazy-img-directive.directive';
import { FollowupQuestionnaireModalComponent } from './components/modals/followup-questionnaire-modal/followup-questionnaire-modal.component';
import { TherapeuticDosesComponent } from './views/therapeutic-doses/therapeutic-doses.component';
import { ImageToRightModule } from './components/image-to-right/image-to-right-module.module.ts.module';
import { Thanks2023Component } from './views/recap/thanks2023/thanks2023.component';
import { AssetsSourcePipe } from './pipes/assets-source.pipe';
import { EnvPipe } from './pipes/env.pipe';
import { IndexComponent } from './views/forums/index/index.component';
import { ShowComponent } from './views/forums/show/show.component';
import { NewComponent } from './views/forums/new/new.component';
import { EditorModule } from '@tinymce/tinymce-angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EditComponent } from './views/forums/edit/edit.component';
import { DonationsComponent } from './views/donations/donations.component';
import { AdminInboxComponent } from './views/admin/admin_inbox.component';
import { PublicSiteComponent } from './views/user/public-site.component';
import { InitialCallComponent } from './views/initial-call/initial-call.component';
import { QuestionnairesDashboardComponent } from './views/questionnaires-dashboard/questionnaires-dashboard.component';
import { AgGridModule } from 'ag-grid-angular';
import { AppointmentsPolicyComponent } from './views/appointments-policy/appointments-policy.component';
import { MenuComponent } from './components/v2/menu/menu.component';
import { InboxUserComponent } from './views/user/inbox_user_without_footer.component';
import { PlanFollowUpSessionsComponent } from './views/user/plan-follow-up-sessions/plan-follow-up-sessions.component';
import { SpecialistsComponent } from './views/follow-up/specialists/specialists.component';
import { BalanceComponent } from './views/user/balance/balance.component';
import { ChangeCoachComponent } from './views/user/change-coach/change-coach.component';
import { InitComponent } from './views/user/init/init.component';


@NgModule({
  declarations: [
    AppComponent,
    UserComponent,
    PublicSiteComponent,
    HeaderComponent,
    PublicHeaderComponent,
    AdminComponent,
    AdminInboxComponent,
    InboxUserComponent,
    RedAlertComponent,
    NotFoundComponent,
    RegisterDoneComponent,
    NeurotestComponent,
    IntegrationComponent,
    WorkbookComponent,
    ReferralsComponent,
    SafeUrlPipe,
    FooterComponent,
    ComplaintsViewComponent,
    CancellationsAndRefundsComponent,
    LazyImgDirective,
    FollowupQuestionnaireModalComponent,
    TherapeuticDosesComponent,
    Thanks2023Component,
    AssetsSourcePipe,
    EnvPipe,
    IndexComponent,
    ShowComponent,
    NewComponent,
    EditComponent,
    DonationsComponent,
    InitialCallComponent,
    QuestionnairesDashboardComponent,
    AppointmentsPolicyComponent,
    MenuComponent,
    PlanFollowUpSessionsComponent,
    SpecialistsComponent,
    BalanceComponent,
    ChangeCoachComponent,
    InitComponent
  ],
  imports: [
    CommonModule,
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot(),
    HttpClientModule,
    NgxBootstrapModule,
    ScrollTopModule,
    BsDropdownModule,
    LoadingComponentsModule,
    ImageToRightModule,
    EditorModule,
    FormsModule,
    ReactiveFormsModule,
    AgGridModule
  ],
  providers: [
    { provide: LOCALE_ID, useValue: $localize.locale || 'es' },
    { provide: ErrorHandler, useValue: Sentry.createErrorHandler({ showDialog: false }) },
    BsDropdownConfig,
    provideClientHydration()
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
const __stripTrailingSlash = (Location as any).stripTrailingSlash;  
(Location as any).stripTrailingSlash = function(url){
  if (url.endsWith('/')) {  
    url=url;  
  }  
  else {  
    url=url+'/';  
  }  
  const queryString$ = url.match(/([^?]*)?(.*)/);
  if (queryString$[2].length > 0) {
    
    let finalUrl = /[^\/]\/$/.test(queryString$[1]) ? queryString$[1] + '.' + queryString$[2] : __stripTrailingSlash(url); 
    return finalUrl.replace(/\/+$/, '')
  }  
  return /[^\/]\/$/.test(url) ? url + '.' : __stripTrailingSlash(url);  
};  